import React from 'react';
import { Row, Col, Button } from 'antd';
import * as Config from '../../Config';

const LoginButton = () => {
    return (
        <div>
            <Row>
                <Col
                    xs={24}
                    align='center'
                    style={{
                        padding: '0.5rem 0 0.5rem 0',
                    }}
                >
                    <Button
                        block
                        type='primary'
                        onClick={() => {
                            const returnTo = window.location.origin;
                            window.location.href = `https://auth.rajchandra.me/login?returnTo=${encodeURIComponent(returnTo)}`;
                        }}
                    >
                        Login
                    </Button>
                </Col>
            </Row>
        </div>
    );
};

export default LoginButton;
